


























import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import { OverviewLayoutITF } from '@/interfaces';
import FieldDefs from './FieldDefs';
import {new_curdate} from '@/claesutils';

interface AddMultipleDaysRec {
    begin: string;
    end: string;
    driver_id: number;
    absencetype_id: number;
}

@Component
export default class ManageDriverAbsencesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public dialogAddMultipleDays = false;
  public recAddMultipleDays: AddMultipleDaysRec = {begin: '', end: '', driver_id: 0, absencetype_id: 0};

  public startAddMultipleDays() {
    this.recAddMultipleDays.begin = this.recAddMultipleDays.end = new_curdate();
    this.dialogAddMultipleDays = true;
  }
  public begin_date_changed() {
    if (this.recAddMultipleDays.begin) {
      if (this.recAddMultipleDays.end) {
        if (this.recAddMultipleDays.end < this.recAddMultipleDays.begin) {
          this.$set(this.recAddMultipleDays, 'end', this.recAddMultipleDays.begin);
        }
      } else {
        this.$set(this.recAddMultipleDays, 'end', this.recAddMultipleDays.begin);
      }
    }
  }
  public async executeAddMultipleDays(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'adddays', rec);
    if (this.$refs.overview) {
      ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData(true);
    }
  }
}
